import React, { Component } from 'react';
import seePic from '../introduce/images/see.png';

class ReadList extends Component{
  constructor(props){
    super(props)
  }
  render(){
    return(
      <a data-id={this.props.data.id} className="read-list" href={`newsDetail.html?newsID=${this.props.data.id}&plat=1`} >
        <div className="read-list-left">
          <div className="read-subtitle">{this.props.data.title}</div>
          <div className="read-note">
            {this.props.data.author_name}
            <img src={seePic} alt="pic" />
            {this.props.data.view_num}热度
          </div>
        </div>
        {this.props.data.imagesList[0] ?
          <div className="read-list-right">
            <img src={this.props.data.imagesList[0]} alt="pic" style={{ width: '100%', height: '75px',borderRadius:'2px' }} />
          </div>
          : ""}
      </a>
    )
  }
}

export default ReadList;